// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../css-loader/dist/cjs.js??ref--10-oneOf-3-1!../../../postcss-loader/src/index.js??ref--10-oneOf-3-2!../../../postcss-loader/src/index.js??ref--10-oneOf-3-3!../../../sass-loader/dist/cjs.js??ref--10-oneOf-3-4!./main.sass");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../../../vue-style-loader/lib/addStylesClient.js").default
var update = add("08eb97d0", content, true, {"sourceMap":false,"shadowMode":false});